var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapesCallouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36612 4.36612C4.60054 4.1317 4.91848 4 5.25 4H19C19.3315 4 19.6495 4.1317 19.8839 4.36612C20.1183 4.60054 20.25 4.91848 20.25 5.25V15.25C20.25 15.5815 20.1183 15.8995 19.8839 16.1339C19.6495 16.3683 19.3315 16.5 19 16.5H14.357L14.3565 16.5009L13.1965 18.4368C13.0839 18.6198 12.9263 18.771 12.7388 18.8758C12.5512 18.9807 12.3399 19.0357 12.125 19.0357C11.9101 19.0357 11.6988 18.9807 11.5112 18.8758C11.3237 18.771 11.1661 18.6198 11.0535 18.4367L11.0498 18.4306L9.89301 16.5H5.25C4.91848 16.5 4.60054 16.3683 4.36612 16.1339C4.1317 15.8995 4 15.5815 4 15.25V5.25C4 4.91848 4.1317 4.60054 4.36612 4.36612ZM19 5.25L5.25 5.25L5.25 15.25H9.89844C10.1146 15.2503 10.3279 15.3071 10.5155 15.4146C10.702 15.5217 10.8576 15.6753 10.967 15.8604L12.1187 17.7826C12.1194 17.7835 12.1202 17.7842 12.1212 17.7847C12.1218 17.7851 12.1225 17.7853 12.1231 17.7855C12.1237 17.7857 12.1244 17.7857 12.125 17.7857C12.1263 17.7857 12.1276 17.7854 12.1288 17.7847C12.1298 17.7842 12.1306 17.7835 12.1313 17.7826L13.283 15.8605C13.3923 15.6753 13.5479 15.5217 13.7345 15.4146C13.9221 15.3071 14.1344 15.2503 14.3506 15.25L19 15.25V5.25Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesCallouts);
export default __webpack_public_path__ + "static/media/shapes-callouts.a47ddf97c9571ed00dab2b5dbb9d1a20.svg";
export { ForwardRef as ReactComponent };